import moment from 'moment'
import Vue from 'vue'

const globalFormatDateTime = 'YYYY-MM-DD'

export const globalEventBus = new Vue()

/**
 *
 * @params specification - Array of objects that specify which items need to be evaluated
 */
export function getDetailDisplayContext (_detailObject, specification) {
  function isEmptyValue (value) {
    if (!value) {
      return true
    }
    if (typeof value === 'string') {
      return value === ''
    }
    if (typeof value === 'number') {
      return false
    }
    if (typeof value === 'boolean') {
      return false
    }
    if (Array.isArray(value)) {
      return value.length === 0
    }
    if (typeof value === 'object') {
      const vals = Object.values(value)
      if (vals.length === 0) {
        return true
      }
      const emptyVals = vals.map(v => {
        return (Array.isArray(value) && v.length === 0) || isEmptyValue(v)
      })
      return emptyVals.every(Boolean)
    }
    return false
  }
  let result = []
  specification.forEach(obj => {
    let cloned = Object.assign({}, obj)
    let keys = cloned.item_key.split('.')
    let value = _detailObject
    if (cloned.title_key) {
      cloned.title_key = value[cloned.title_key]
    }
    for (let key of keys) {
      try {
        value = value[key]
      } catch (e) {
        value = ''
      }
    }
    cloned.has_value = !isEmptyValue(value)
    cloned.value = value
    result.push(cloned)
  })
  return result
}

export function dateTimeFormat (date, formatDateTime = globalFormatDateTime) {
  return moment(date).format(formatDateTime)
}

// custom function for deep cloning objects
export function deepCloneObject (obj) {
  if (!obj) {
    return obj
  }
  let clonedObj, value, key
  clonedObj = Object.assign(Object.create(Object.getPrototypeOf(obj)), obj)
  for (key in obj) {
    value = obj[key]
    clonedObj[key] = (typeof value === 'object') ? deepCloneObject(value) : value
  }
  return clonedObj
}

/**
 *
 * @params arr - Array of values
 * @params dict - Dictionary where the key is that value that should be updated
 */
export function updateArrayForValue (arr, dict) {
  for (let key in dict) {
    let index = arr.findIndex((val) => {
      return val === key
    })
    if (index >= 0) {
      arr[index] = dict[key]
    }
  }
}

/**
 * This funciton creates an array of classes given certain values and size
 *
 * @params values - Array of objects: the key of each object is the index and the value for that key is the class
 * @params size - Integer showing the size of the array
 */
export function assignLayoutClasses (values, size) {
  let classes = []
  for (let index = 0; index < size; index++) {
    if (values[index]) {
      classes.push(values[index])
    } else {
      classes.push(values['default'])
    }
  }
  return classes
}

/**
 * This funciton gets an array of objects and an object key and returns an array with each key and its number of occurances
 *
 * @params objArr - Array of objects: the array on which the summary is made
 * @params summaryKey - a key that is part of each object in the array
 */
export function arrayOfObjectsSummarizer (objArr, summaryKey) {
  let summary = []
  for (let obj of objArr) {
    let foundObj = summary.find(currObj => {
      return currObj.name === obj[summaryKey]
    })
    if (foundObj) {
      foundObj.count++
    } else {
      summary.push({
        name: obj[summaryKey],
        count: 1
      })
    }
  }
  return summary
}

/**
 * This funciton takes two dates and sorts them in ascending order, used as a sorting function inside sort
 *
 * @params dateA - an object with property periodStartDate which is a date string in the following format: 'YYYY-MM-DD'
 * @params dateB - an object with property periodStartDate which is a date string in the following format: 'YYYY-MM-DD'
 */
export function sortPeriodDates (dateA, dateB) {
  if (moment(dateA.periodStartDate).isBefore(dateB.periodStartDate)) {
    return -1
  } else if (moment(dateA.periodStartDate).isAfter(dateB.periodStartDate)) {
    return 1
  }
  return 0
}

/**
 * This funciton returns the browser as an object
 * @params vm - the current Vue instance
 */
export function getBrowserInfo (vm) {
  return {
    name: vm.$browserDetect.meta.name,
    version: vm.$browserDetect.meta.version,
    userAgent: vm.$browserDetect.meta.ua
  }
}

/**
 * This funciton verifies the support of the following browsers:
 * - Chrome - fully supported
 * - Firefox - fully supported
 * - IE - Edge, IE11 supported
 * - Safari - 9+ supported
 */
export function getBrowserCompatibility (vm) {
  const all = 'allVersions'
  let browser = getBrowserInfo(vm)
  let supportedBrowsers = [
    {
      name: 'Chrome',
      version: all
    },
    {
      name: 'Firefox',
      version: all
    },
    {
      name: 'Edge',
      version: all
    },
    {
      name: 'Safari',
      version: 10
    },
    {
      name: 'IE',
      version: 11
    }
  ]
  for (let supported of supportedBrowsers) {
    if (supported.name.toLowerCase() === browser.name.toLowerCase()) {
      if (supported.version <= browser.version || supported.version === all) {
        return true
      }
    }
  }
  return false
}

/**
 * Casts a value from a string representation to its actual type and returns
 * @params value - the value that needs to be parsed
 */
export function parseValue (value) {
  if (isNaN(value)) {
    if (value === 'true') {
      return true
    }
    if (value === 'false') {
      return false
    }
    return value
  }
  return parseInt(value)
}

/**
 * Generates a random uuid in the format: xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
 */
export function uuidv4 () {
  var crypto = window.crypto || window.msCrypto
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  )
}

/*
 * Retrieves any value from an object structure (data)
 * Considers nested values such as firstPart.secondPart.etc.value
 */
 export function getNestedValue (data, nestedKey) {
  for (let key of nestedKey.split('.')) {
    if (!data) return
    data = data[key]
  }
  return data
}

/*
 *Takes query from url and transforms
 *it in the format of params for filters
 */
export function queryToFilters (query) {
  let filters = {}
  let castTypes = ['case_type', 'service', 'state', 'reviewer', 'is_reported', 'has_invoice']
  for (const [key, val] of Object.entries(query)) {
    if (castTypes.includes(key)) {
      let numberVal = []
      let newVal = val
      if (typeof newVal === 'string') {
        newVal = [newVal]
      }
      newVal.forEach((x) => {
        numberVal.push(parseInt(x))
      })
      filters[key] = numberVal
    }
  }
  return filters
}

/*
 *Takes query from url and transforms
 *it in the format of params for filters
 */
export function queryToFiltersAuditors (query) {
  let filters = {}
  let castTypes = ['service', 'manager', 'date_lte', 'date_gte']
  for (const [key, val] of Object.entries(query)) {
    if (castTypes.includes(key)) {
      filters[key] = val
    }
  }
  return filters
}

/*
 *Takes query from url and transforms
 *it in the format of params for filters for PublicCertificateListView
 */
export function queryToFiltersPublic (query) {
  let filters = {}
  let castTypes = ['certificate_number', 'service', 'name', 'company', 'qualification', 'city', 'county']
  for (const [key, val] of Object.entries(query)) {
    if (castTypes.includes(key)) {
      let newVal = val
      filters[key] = newVal
    }
  }
  return filters
}

/*
 *Takes query from url and gets page number from there
 */
export function getPageFromQuery (query) {
  let filters = query
  let castTypes = ['page']
  let page = 1
  for (const [key, val] of Object.entries(filters)) {
    if (castTypes.includes(key)) {
      page = val
      if (typeof page === 'string') {
        page = parseInt(page)
      }
    }
  }
  return page
}

/*
 *Takes query from url and gets search from there
 */
export function getSearchFromQuery (query) {
  let filters = query
  let castTypes = ['search']
  let search
  for (const [key, val] of Object.entries(filters)) {
    if (castTypes.includes(key)) {
      search = val
      if (typeof search === 'string') {
        return search
      }
    }
  }
}
